import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import history from 'dashboard/history';
import moment from 'moment';
import { numeral } from 'lib/helpers';
import CDNManager from 'dashboard/CDN/CDNManager';
import Toolbar from './Toolbar.react';
import Button from 'components/Button/Button.react';
import stylesButton from 'components/Button/Button.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import SegmentSelect from 'components/SegmentSelect/SegmentSelect.react';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import BrowserMenu from 'components/BrowserMenu/BrowserMenu.react';
import MenuItem from 'components/BrowserMenu/MenuItem.react';
import Separator from 'components/BrowserMenu/Separator.react';
import LoaderDots from 'components/LoaderDots/LoaderDots.react';
import BarChart from 'components/Charts/BarChart.react'
// import PercentageChart from 'components/Charts/PercentageChart.react'
import chartStyles from 'components/Charts/Charts.scss';

import styles from './CDN.scss'
import settingsStyles from 'dashboard/Settings/Settings.scss';

export default class Overview extends Component {
  constructor(props) {
    super();

    this.section = 'CDN';
    this.subsection = 'Overview';

    this.state = {
      loading: true,
      segmentTime: '30',
      newData: {},
      CDNSites: [],
      cacheHits: 0,
      cacheMisses: 0,
      hits: 0,
      sitesCount: 0,
      transfer: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ loading: true });

    CDNManager.CDNServiceSitesData().then(({CDNSites}) => {
      this.setState({ CDNSites, loading: false });
    });
  }

  componentDidMount() {
    CDNManager.CDNServiceSitesData().then(({CDNSites}) => {
      SashiDo.CDNServicesMetricsSummary(CDNSites).then((sitesData) => {
        const ids = [];

        CDNSites.forEach((item) => {
          ids.push(item.objectId)
        });

        SashiDo.CDNServicesMetricsBytes({
          ids,
          from: moment().subtract(30, 'days').unix(),
          to: moment().unix(),
          by: 'day',
        }).then((graphBytesData) => {
          this.init({ CDNSites, sitesData, graphBytesData });
        });
      });
    });
  }

  init({ CDNSites, sitesData, graphBytesData }) {
    const days = this.state.segmentTime;
    const labels = [];
    const datasets = [];

    graphBytesData.forEach((item) => {
      labels.push(moment.unix(item.timestamp).format('MMM DD'));
      datasets.push(item.bytes ? item.bytes : 0);
    });

    this.setState({
      segmentTime: days,
      CDNSites,
      originalData: graphBytesData,
      cacheHits: sitesData.cacheHits,
      cacheMisses: sitesData.cacheMisses,
      hits: sitesData.hits,
      sitesCount: sitesData.sitesCount,
      transfer: sitesData.transfer,
    });

    this.resolutionChange(this.state.segmentTime);
  }

  resolutionChange(days) {
    const newData = this.state.originalData;

    const labels = [];
    const datasets = [];

    newData.forEach((item) => {
      labels.push(moment.unix(item.timestamp).format('MMM DD'));
      datasets.push(item.bytes ? item.bytes : 0);
    });

    this.setState({
      loading: false,
      segmentTime: days,
      newData: {
        labels: labels.slice(0, days),
        datasets: [
          {
            values: datasets.slice(0, days),
          }
        ]
      },
    });
  }

  renderRow(data) {
    let classes = [stylesButton.tableButton, stylesButton.blue];

    return (
      <tr key={data.objectId}>
       <td>{data.domains[0]}</td>
       <td>
         <div className='actions'>
           <a
             className={classes.join(' ')}
             href='javascript:;'
             onClick={() => { history.push(`/products/cdn/${data.objectId}/overview`)}}>Manage</a>
         </div>
       </td>
      </tr>
    );
  }

  render() {
    let classes = [settingsStyles.settings_page, settingsStyles.default];

    const REPORTS = (
      <BrowserMenu title='Reports' icon='icon-area-chart'>
        <MenuItem
          text='Hourly Breakdown'
          onClick={() => {}}
        />
        <MenuItem
          text='Top 50 Files'
          onClick={() => {}}
        />
        {
          // <MenuItem
          //   text='File Types'
          //   onClick={() => {}}
          // />
        }
        <MenuItem
          text='Status Codes'
          onClick={() => {}}
        />
        <MenuItem
          text='Edge Locations'
          onClick={() => {}}
        />
        <MenuItem
          text='Logs'
          onClick={() => {}}
        />
        {
          // <MenuItem
          //   text='Daily Files'
          //   onClick={() => {}}
          // />
        }
      </BrowserMenu>
    );

    if(this.state.loading) {
      return (
        <div className={classes.join(' ')}>
          <Toolbar {...this.props} subsection={this.props.route.name}>
            <div>
              {REPORTS}
              <div style={{ width: 40 }}/>
              <Button color='green' icon='icon-plus' value='Create New Site' onClick={() => history.push('/products/cdn/create')} />
            </div>
          </Toolbar>
          <PreLoader loading={this.state.loading} />
        </div>
      );
    }

    return (
      <div className={classes.join(' ')}>
        {
          <Toolbar {...this.props} subsection={this.props.route.name}>
            <div>
              {REPORTS}
              <div style={{ width: 40 }}/>
              <Button color='green' icon='icon-plus' value='Create New Site' onClick={() => history.push('/products/cdn/create')} />
            </div>
          </Toolbar>
        }
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            <div className={styles.holder}>
              <h2>Summary</h2>
              <div className={styles.summary}>
                <div className={styles.box}><h2>{this.state.sitesCount}</h2><span>Sites</span></div>
                <div className={styles.box}><h2>{numeral(this.state.transfer, '0.00 b', true)}</h2><span>Transferred</span></div>
                <div className={styles.box}><h2>{numeral(this.state.cacheHits, '0 a', true)}</h2><span>Cache Hits</span></div>
                <div className={styles.box}><h2>{numeral(this.state.cacheMisses, '0 a', true)}</h2><span>Non-Cache Hits</span></div>
                <div className={styles.box}><h2>{numeral(this.state.hits, '0 a', true)}</h2><span>Total Hits</span></div>
              </div>

              {
                Object.keys(this.state.newData).length !== 0 &&
                  <BarChart
                    title='Bandwidth Usage'
                    unit={'Requests'}
                    dataFormat={'0b'}
                    data={this.state.newData}
                    height={200}
                    segmentTimeComponent={
                      <SegmentSelect
                        labels={['7 Days', '14 Days', '30 Days']}
                        values={['7', '14', '30']}
                        current={this.state.segmentTime}
                        onChange={(days) => {
                          this.resolutionChange(days);
                        }} />
                    }
                    colors={['#0092ff']}
                  />
              }

              <h2>My Sites</h2>
              <div className={styles.sites}>
                <SashiDoTable className='hover'>
                  <colgroup>
                    <col width="100%" />
                    <col width="0" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Sites</th>
                      <th><div className='actions'>Action</div></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.CDNSites.map((row) => this.renderRow(row))}
                  </tbody>
                </SashiDoTable>
              </div>
            </div>

          </div>
        </PreLoader>
      </div>
    );
  }
}
